import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AppService, CoreProxyService, CoreTypes, LabelValue } from 'common-cloudstudio';
import { forkJoin, Observable, Subscription, Subject, EMPTY } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ApolusService } from 'src/app/customer-modules/apolus/shared/services/apolus.service';
import { ApolusProxyService, ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';
import { GearAppService } from 'common-gear';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  @Output() dateFilterRequested = new EventEmitter<void>();

  facilityId: number = null;
  dashboardId: number = 661;
  accessToken: string = null;
  formParameters: CoreTypes.FormParameter[] = [];
  subscriptions: Subscription[] = [];
  contracNumberList: LabelValue<number>[] = [];
  private _contracNumber: LabelValue<number> = null;
  get contracNumber(): LabelValue<number> {
    return this._contracNumber;
  }
  set contracNumber(value: LabelValue<number>) {
    if (this._contracNumber?.value !== value?.value) {
      this._contracNumber = value;
      if (this._contracNumber?.value && !this.isGettingUserData) {
        this.getUserData();
      }
    }
  }
  searchText: string = '';
  private searchSubject = new Subject<string>();
  user = {
    name: 'JosÃ© Luis PÃ©rez',
    address: 'Los Alpes No. 2760. Int. 6',
    colony: 'La federacha',
    zip: '44300',
    city: 'Guadalajara',
    state: 'Jalisco',
    tariff: 'Residencial A1',
    sector: 'A1',
    average: 30,
    stateValve: 'Abierta'
  };
  allowValveChange = true;
  isSidebarOpen: boolean = false;
  currentDate: string = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toLocaleDateString('es-MX');
  loading: boolean = false;
  private isGettingUserData: boolean = false;
  dateFrom: CoreTypes.DateTimeDT;
  dateTo: CoreTypes.DateTimeDT;
  deviceModelImage: CoreTypes.HtmlWidgetData = {
    Url: 'https://gear-dev.cloud.studio/FileData/FileAssets/fbc0a5e3-5524-43ff-884a-88577f7badf5.png'
  };
 
  userData: ApolusTypes.UserDashboard = {
    Data: {
      FirstName: 'JosÃ© Luis',
      LastName: 'PÃ©rez',
      RateDescription: 'Residencial A1',
      SectorDescription: 'A1',
      AddressID: 1,
      AdminArea2ID: 2,
      ApartmentBuilding: 'Los Alpes No. 2760. Int. 6',
      ClientExternalID: '10202230670',
      ContractID: 1,
      ClientID: 1,
      Device: {
        DeviceID: 1,
        Address: 'DUE2303230670',
        AutomaticFirmwareUpdate: true,
        Comments: 'Device Comments',
        DefaultDashboardID: 1,
        DefaultViewID: 1,
        DeviceGatewayKnownName: 'Device Gateway Known Name',
        DeviceModel: 'Device Model',
        DeviceModelID: 1,
        FacilityID: 1,
        FirmwareVersion: 'Firmware Version',
        GatewayID: 1,
        GeoLocation: {
          Latitude: 19.432607,
          Longitude: -99.133209
        },
        IconID: 1,
        IsOnline: true,
        NameValues: [],
        NumberOfEndpoints: 1,
        NumberOfVisibleEndpoints: 1,
        Parameters: [],
        PrivateKey: 'Private Key',
        NewFirmwareAvailable: true,
        TechnologyID: 1,
        TimeZoneID: 1,
        ScriptObjectID: '1',
        Description: 'Device Description',
        ClientID: 1,
      },
      ObservationsLine1: 'Observations Line 1',
      ObservationsLine2: 'Observations Line 2',
      ObservationsLine3: 'Observations Line 3',
      ContractExternalID: '10202230670',
      FacilityID: 1,
      RateID: 1,
      SectorID: 1,
      StreetName: 'Los Alpes',
      StreetNumber: '2760',
      UniqueID: 324,
      ZipCode: '44300',
    },
    EventsTable: {
      Url: "https://mma-dev.cloud.studio/FileData/ReportCache/1ad5054b802cbbde0ea53f39e95f090c.html"
    },
    HistoryConsumption: {
      Url: 'https://mma-dev.cloud.studio/FileData/ReportCache/1ad5054b802cbbde0ea53f39e95f090c.html'
    },
    RecentConsumption: {
      AlarmPoints: [],
      LeftAxis: {
        AxisTitle: '',
        MaxValue: 25,
        MinValue: 0
      },
      RightAxis: null,
      Series: [
        {
          AxisID: 1,
          Color: 1099489,
          DataPointFormat: 1,
          LineWidth: 1,
          OfflinePeriods: [],
          Timestamps: [ 
            1760400000,
            1760486400,
            1760572800,
            1760659200,
            1760745600,],
          Title: "Promedio",
          Type: 1,
          Values: [9, 13, 15, 17, 24]
        },
      ],
      Ranges: [],
      TimeAxisMax: {
        Date: {
          Day: 30,
          Month: 7,
          Year: 2025
        },
        Time: {
          Hour: 15,
          Millisecond: 501,
          Minute: 14,
          Second: 2
        }
      },
      TimeAxisMin: {
        Date: {
          Day: 17,
          Month: 7,
          Year: 2025
        },
        Time: {
          Hour: 0,
          Millisecond: 0,
          Minute: 0,
          Second: 0
        }
      },
      TimeAxisFormat: 'dd/MM HH:mm',
    }
  };

  historyTableData: {
    Table: {
      ShowHeader: true,
      Columns: [
        { Key: "alertType", Title: "", WidthPixels: 50, Alignment: 0 },
        { Key: "alarm", Title: "Alarma de Fuga", WidthPixels: 150, Alignment: 0 },
        { Key: "clientId", Title: "Id. De Cliente", WidthPixels: 120, Alignment: 1 },
        { Key: "contractNo", Title: "No. Contrato", WidthPixels: 120, Alignment: 1 },
        { Key: "name", Title: "Nombre", WidthPixels: 200, Alignment: 0 },
        { Key: "address", Title: "Domicilio", WidthPixels: 200, Alignment: 0 },
        { Key: "status", Title: "", WidthPixels: 100, Alignment: 2 }
      ],
      Rows: [
        {
          BackgroundColor: null,
          Data: {
            alertType: { Type: "icon", IconClass: "fa fa-warning", Color: "#ff0000", Title: "Severidad Alta" },
            alarm: { Type: "text", Value: "Posible fuga en proceso, flujo de agua continuo por mÃ¡s de 24hs" },
            clientId: { Type: "text", Value: "10202230670" },
            contractNo: { Type: "text", Value: "10202230670" },
            name: { Type: "text", Value: "JosÃ© Luis Perez" },
            address: { Type: "text", Value: "Alpes 2760 int 6" },
            status: { Type: "dropdown", Value: "Alerta", Options: ["Alerta", "En curso", "Resuelta"], OnChange: "changeStatus" }
          }
        },
        {
          BackgroundColor: null,
          Data: {
            alertType: { Type: "icon", IconClass: "fa fa-warning", Color: "#ffa500", Title: "Severidad Media" },
            alarm: { Type: "text", Value: "Posible fuga en proceso, flujo de agua continuo por mÃ¡s de 24hs" },
            clientId: { Type: "text", Value: "10202230670" },
            contractNo: { Type: "text", Value: "10202230670" },
            name: { Type: "text", Value: "JosÃ© Luis Perez" },
            address: { Type: "text", Value: "Alpes 2760 int 6" },
            status: { Type: "dropdown", Value: "En curso", Options: ["Alerta", "En curso", "Resuelta"], OnChange: "changeStatus" }
          }
        },
        {
          BackgroundColor: null,
          Data: {
            alertType: { Type: "icon", IconClass: "fa fa-warning", Color: "#ff0000", Title: "Severidad Alta" },
            alarm: { Type: "text", Value: "Posible fuga en proceso, flujo de agua continuo por mÃ¡s de 24hs" },
            clientId: { Type: "text", Value: "10202230670" },
            contractNo: { Type: "text", Value: "10202230670" },
            name: { Type: "text", Value: "JosÃ© Luis Perez" },
            address: { Type: "text", Value: "Alpes 2760 int 6" },
            status: { Type: "dropdown", Value: "Alerta", Options: ["Alerta", "En curso", "Resuelta"], OnChange: "changeStatus" }
          }
        }
      ]
    }
  }


  constructor(
    public _appService: AppService,
    private _coreProxyService: CoreProxyService,
    public _apolusService: ApolusService,
    private _apolusProxyService: ApolusProxyService,
    private _cdr: ChangeDetectorRef,
    public _gearAppService: GearAppService
  ) {}

  ngOnInit(): void {
    this.initializeDateRanges();
    this.initData();
    this.setupSearchDebounce();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.searchSubject.complete();
  }

  setupSearchDebounce(): void {
    const searchSubscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((searchValue: string) => {
        const trimmedValue = searchValue?.trim() || '';
        if (trimmedValue.length >= 3) {
          return this.getContractsByClientExternalID(trimmedValue);
        } else if (trimmedValue.length === 0) {
          return this.getContracts();
        } else {
          return EMPTY;
        }
      })
    ).subscribe({
      next: (contracts: LabelValue<number>[]) => {
        this.contracNumberList = contracts;
        if (this.contracNumberList.length > 0) {
          if (!this._contracNumber || !this.contracNumberList.find(c => c.value === this._contracNumber.value)) {
            this.contracNumber = this.contracNumberList[0];
          }
        }
        this._cdr.detectChanges();
      },
      error: (error) => {
        this._appService.showException(error);
      }
    });

    this.subscriptions.push(searchSubscription);
  }

  search(event: Event): void {
    const target = event.target as HTMLInputElement;
    const value = target.value || '';
    this.searchSubject.next(value);
  }

  initData() {
    forkJoin([
      this.getContracts(),
    ]).subscribe({
      next: (results) => {
        this.contracNumberList = results[0];
        if (this.contracNumberList.length > 0) {
          this.contracNumber = this.contracNumberList[0];
        }
        this._cdr.detectChanges();
      },
      error: (error) => {
        this._appService.showException(error);
      }
    });
  }

  updateValveState(newState: string) {
    this.user.stateValve = newState;
  }
  
  openDateFilter(): void {
    this.dateFilterRequested.emit();
  }

  toggleFiltersSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeFiltersSidebar() {
    this.isSidebarOpen = false;
  }

  applyFilters(){
    this.getUserData();
  }

  initializeDateRanges(): void {
    const today = new Date();
    const dateFrom = new Date(today);
    dateFrom.setDate(today.getDate() - 14);
    dateFrom.setHours(0, 0, 0, 0);
    
    this.dateFrom = new CoreTypes.DateTimeDT();
    this.dateFrom.Date = {
      Day: dateFrom.getDate(),
      Month: dateFrom.getMonth() + 1,
      Year: dateFrom.getFullYear()
    };
    this.dateFrom.Time = {
      Hour: 0,
      Minute: 0,
      Second: 0,
      Millisecond: 0
    };
    
    const dateTo = new Date(today);
    dateTo.setHours(23, 59, 59, 999);
    
    this.dateTo = new CoreTypes.DateTimeDT();
    this.dateTo.Date = {
      Day: dateTo.getDate(),
      Month: dateTo.getMonth() + 1,
      Year: dateTo.getFullYear()
    };
    this.dateTo.Time = {
      Hour: 23,
      Minute: 59,
      Second: 59,
      Millisecond: 999
    };
  }

  getUserData() {
    if (this.isGettingUserData) {
      return; 
    }
    this.isGettingUserData = true;
    this.loading = true;
    this._apolusProxyService.ApolusService.GetUserDashboard(
      this._appService.getAccessToken(),
      this.contracNumber?.value,
      this.dateFrom,
      this.dateTo,
      data => {
        this.userData = data;
        this.loading = false;
        this.isGettingUserData = false;
      },
      error => {
        this._appService.showException(error);
        this.loading = false;
        this.isGettingUserData = false;
      }
    )
  }

  getContracts(): Observable<LabelValue<number>[]> {
    return new Observable(observer => {
      this._apolusProxyService.ApolusService.EnumContracts(
        this._appService.getAccessToken(),
        data => {
          let items: LabelValue<number>[] = [];
          data.forEach(contract => {
            const item: LabelValue<number> = {
              label: contract.ExternalID ? contract.ExternalID : contract.ContractID.toString(),
              value: contract.ContractID
            };
            items.push(item);
          });
          observer.next(items);
          observer.complete();
        },
        error => {
          this._appService.showException(error);
          observer.error(error);
        }
      )
    });
  }

  getContractsByClientExternalID(clientExternalID: any): Observable<LabelValue<number>[]> {
    return new Observable(observer => {
      this._apolusProxyService.ApolusService.EnumContractByClientExternalID(
        this._appService.getAccessToken(),
        clientExternalID,
        data => {
          let items: LabelValue<number>[] = [];
          data.forEach(contract => {
            const item: LabelValue<number> = {
              label: contract.ExternalID ? contract.ExternalID : contract.ContractID.toString(),
              value: contract.ContractID
            };
            items.push(item);
          });
          observer.next(items);
          observer.complete();
        },
        error => {
          this._appService.showException(error);
          observer.error(error);
        }
      )
    });
  }
}
